module.exports = {"Custom Password Reset Email":"Notifica di Ripristino Password","Reset Password Notification":"Notifica di Ripristino Password"};